module.exports = "https://coursera_assets.s3.amazonaws.com/images/84fa5cbade87fc0dfebfbccf3b239ff4.png";